import { render, staticRenderFns } from "./CustomerOrderFollow.vue?vue&type=template&id=618e3a7a&scoped=true"
import script from "./CustomerOrderFollow.vue?vue&type=script&lang=js"
export * from "./CustomerOrderFollow.vue?vue&type=script&lang=js"
import style0 from "./CustomerOrderFollow.vue?vue&type=style&index=0&id=618e3a7a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618e3a7a",
  null
  
)

export default component.exports